<template>
  <div class="u-width-100">
    <topNav :showRight="showRight" :showUser="showUser" @login="login" @register="goRegister"></topNav>
    <div class="top-menu" v-if="showMenu">
      <img src="../assets/logo.png" class="logo" alt="" style="" @click="goIndex" />
      <div class="menu-box u-flex u-row-between font-14 u-col-center">
        <Menu mode="horizontal" :active-name="choosetabs" class="u-flex1 u-font-weight cursor" @on-select="tabsClick">
          <div v-for="(item, index) in menu" :key="item.code">
            <Submenu :name="index" v-if="item.subDict.length > 0" >
              <template #title>
                <span @click="clickSub(item.itemValue)">{{ item.itemCode }}</span>
              </template>
              <MenuItem v-for="(items, indexs) in item.subDict" :key="items.id" :name="item.reserve1 + '-' + indexs" :to="items.itemValue">{{ items.itemCode }}</MenuItem>
            </Submenu>
            <MenuItem :name="index" v-else :to="item.itemValue">{{ item.itemCode }}</MenuItem>
          </div>
        </Menu>
        <div class="login-box" v-if="(token == null || token == '' || token == undefined) && (userInfo == null || userInfo == '' || userInfo == undefined)">
          <span class="cursor hover-span" @click="click(1)">登录</span>
          <span class="cursor hover-span" @click="click(2)">注册</span>
        </div>
        <div class="login-box" v-else>


          <span class="cursor hover-span" @click="click(3)">退出登录</span>

          <span class="hover-span" style="color: #77ff00;" v-if="userInfo && userInfo.username">  <Avatar style="background-color: #87d068" icon="ios-person" />&nbsp;{{ userInfo.username
          }}，欢迎您！</span>
          <span class="hover-span" style="color: #77ff00;" v-else-if="userInfo && userInfo.email">{{ userInfo.email
          }}，欢迎您！</span>
          <span class="hover-span" style="color: #77ff00;" v-else-if="userInfo">{{ userInfo.mobilephone | phoneFilter()
          }}，欢迎您！</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import topNav from "../components/topNav.vue"
import * as configData from "../views/config"
export default {
  name: 'topTitle',
  components: {
    topNav
  },
  props: {
    choosetabs: String,
    showRight: {
      type: Boolean,
      default: false
    },
    showUser: {
      type: Boolean,
      default: false
    },
    showMenu: {
      type: Boolean,
      default: true
    },
    userInfoData: {
      type: Object,
      default: () => JSON.parse(localStorage.getItem('userinfo'))
    }
  },
  data() {
    return {
      token: localStorage.getItem('token'),
      url: configData.topUrl,
      userInfo: JSON.parse(localStorage.getItem('userinfo')),
      // userInfo: {},
      userType: JSON.parse(localStorage.getItem('userinfo')) ? JSON.parse(localStorage.getItem('userinfo')).userType : null,
      menu: []
    }
  },
  watch: {
    token: {
      handler(newVal) {
        this.getMenu(newVal)
      },
      immediate: true
    },
  },
  created() {
    this.getLogin()
    // this.$store.dispatch("acSetMenu")
    // this.menu = this.$store.state.menu
  },
  filters: {
    phoneFilter(val) {
      return val ? val.substr(0, 3) + '****' + val.substr(7, val.split('').length) : ''
    }
  },
  mounted() {
    document.body.style.backgroundColor = '#f2f2f2'; // 修改背景色
  },
  methods: {
    getLogin() {
      this.$util.post({
        params: {},
        showLoading: false,
        url: '/dict/checkToken',
        success: (res) => {
          if (res.resultCode == 200) {
            if(res.data == '0') {
              localStorage.removeItem('userinfo')
                localStorage.removeItem('token')
                this.userInfo = null
            }
          }
        }
      });
    },
    async getMenu() {
      await this.$util.post({
        params: {
          "data": {
            userType: JSON.parse(localStorage.getItem('userinfo')) ? JSON.parse(localStorage.getItem('userinfo')).userType : 0
          }
        },
        url: '/dict/getMenu',
        success: res => {
          if (res.resultCode == 200) {
            this.menu = res.data
          } else {
            this.$Message.error('查询失败!');
          }
        },
        error: (err) => {
          console.log('失败', err)
        }
      });
    },
    goIndex() {
      this.$router.push({
        path: "/",
      });
    },
    click(type) {
      if (type == 3) {
        localStorage.removeItem('token')
        localStorage.removeItem('userinfo')
        let proxy = this.$route.path
        this.$store.commit('setPath', proxy ? proxy : '/')
        localStorage.setItem('lastVisitPath', proxy ? proxy : '/');
        console.log(111, proxy, this.$store.state.lastVisitPath)
        window.location.href = `http://global.aitrans.org.cn/old/ClientUser/clientUserAction_exit.do`
        // window.location.href = `http://y406x20468.qicp.vip/old/ClientUser/clientUserAction_exit.do`
        return
      }
      this.$router.push({
        path: type == 1 ? "/login" : "/register",
      });
    },
    tabsClick(e) {
      console.log(e)
      // if (e == '1-1') {
      //   window.location.href = this.userType == 5 ? 'http://global.aitrans.org.cn/old/translator/translatorAction_getOrderCount.do' : 'http://global.aitrans.org.cn/old/cilentCustomer/myOrdersUI.do'
      // } else if (e == '2') {
      //   let url = `http://global.aitrans.org.cn/old/cilentCustomer/publishNeed.do`
      //   window.location.href = url
      // } else {
      //   let i = this.url.findIndex(item => item.name == e)
      //   if (i > -1) {
      //     window.location.href = this.url[i].url
      //   }
      // }
    },
    clickSub(type) {
      if(type == "http://global.aitrans.org.cn/#/placeOrder" && !JSON.parse(localStorage.getItem('userinfo')).username) {
        this.$Message.info('请联系项目经理完善资料或者自行修改资料！');
        return
      }
      window.location.href = type
    },
    login() {
      this.$router.push({
        path: "/login"
      });
    },
    goRegister() {
      this.$router.push({
        path: "/register"
      });
    },
  }
}
</script>

<style scoped lang="scss">
.top-nav {
  width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  .top-nav-left {
    span {
      margin-left: 50px;
    }

    span:first-child {
      margin-left: 0;
    }
  }
}

.top-box {
  height: 35px;
  line-height: 35px;
  background: #3a3f51;
  color: #fff;
  position: fixed;
  z-index: 999;
}

.logo {
  width: 240px;
  height: auto;
  cursor: pointer;
  margin-left: 45px;
  margin-bottom: 15px;
}

.top-menu {
  width: 1200px;
  padding: 56px 0 10px;
  margin: 0 auto;
}

.menu-box {
  height: 40px;
  margin-bottom: 0px;
  width: 1200px;
  background: #08A5E0;
  border-radius: 5px;
  color: #fff;
  padding: 0 20px;
}

::v-deep .ivu-menu-horizontal.ivu-menu-light:after {
  background: #08A5E0 !important;
}

::v-deep .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu {
  color: #fff;
}

::v-deep .ivu-menu-light {
  background-color: #08A5E0;
}

::v-deep .ivu-menu,
.ivu-menu-item {
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  font-weight: normal;
}

::v-deep .ivu-menu-horizontal .ivu-menu-submenu .ivu-select-dropdown .ivu-menu-item {
  font-size: 14px !important;
  text-align: center;
  height: 40px;
  line-height: 40px;
  padding: 0;
  color: #fff;
}

::v-deep .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover {
  background-color: #07BB07;
  color: #fff;
  border-bottom: none;
}

::v-deep .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover {
  background-color: #07BB07;
  color: #fff;
}

::v-deep .ivu-menu-light.ivu-menu-horizontal .ivu-menu-drop-list .ivu-menu-item:hover {
  background-color: #08A5E0;
}

::v-deep .ivu-select-dropdown {
  padding: 0;
  margin: 3px 0;
  color: #fff;
  background: #4169E1;
}

.hover-span {
  color: #fff3e3;
  margin: 0 20px;
}

.hover-span:hover {
  color: #77ff00;
}
</style>
